// extracted by mini-css-extract-plugin
export var bodySections = "_5w-8";
export var gray = "_5w-7";
export var green = "_5w-4";
export var iconContainer = "_5w-9";
export var iconWidgetContainer = "_5w-1";
export var phoneIcon = "_5w-2";
export var red = "_5w-5";
export var statusDot = "_5w-3";
export var widgetContainer = "_5w-0";
export var yellow = "_5w-6";